export const infos = {
  options: {
    fields: {
      // Possible identifiers
      process_kind: 'Tipo do processo',
      process_number: 'Número do processo',
      process_identifier: 'Identificador do processo',
      tad_number: 'Número do TAD',
      number: 'Número',

      // Person possible identifiers
      cpf_cnpj: 'CPF/CNPJ',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      name: 'Nome',

      // TRF, TJ, PJE
      distribution_date: 'Data da Distribuição',
      distribution_time: 'Hora da Distribuição',
      last_change: 'Última Alteração',
      last_change_date: 'Data da Última Alteração',
      last_change_time: 'Hora da Última Alteração',
      reporter: 'Relator',
      in_secrecy_of_justice: 'Em segredo de justiça?',
      instance: 'Instância',
      cause_value: 'Valor da Causa',
      competence: 'Competência',
      court_holder: 'Tribunal',
      page_member: '',
      subject: 'Assunto',
      process_class: 'Tipo do processo',
      process_value: 'Valor do processo',
      applicants: {
        // Participantes
        name: 'Nome',
        kind: 'Tipo',
      },

      // CEAF
      ordinance_number: 'Código da Sanção',
      dou_publication_date: 'Data da Publicação no Diário Oficial da União',
      dou_page: 'Página do Diário Oficial da União',
      dou_section: 'Seção do Diário Oficial da União',
      kind: 'Categoria da Sanção',
      legal_foundation: 'Fundação Legal',

      // Unabled people
      deliberation: 'Deliberação',
      judgment_date: 'Data do Julgamento',
      final_date: 'Data Final',

      // Ibama assessement
      infraction_type: 'Tipo da Infração',
      date: 'Data',
      state: 'Estado',
      city: 'Cidade',
      ai_number: 'Número do AI', // ?
      fine_value: 'Valor da Multa',
      debit_status: 'Status do Débito',
      sanctions_applied: 'Sanções Aplicadas',

      // Ibama embargo
      tad_serie: 'Série do TAD',
      area: 'Área',
      property_location: 'Local da Propriedade',
      uf_embargo: 'UF do Embargo',
      city_embargo: 'Cidade do Embargo',
      ibge_city_code_embargo: 'Código da Cidade do Embargo no IBGE',
      neighborhood: 'Bairro',
      address: 'Endereço',
      judgment: 'Sentença',
      infringement: 'Infringimento',
      list_insertion_date: 'Data de Inserção na Lista',

      // CNEP
      register_number: 'Registro',
      sanction_code: 'Código de Sanção',
      start_date: 'Data Inicial',
      end_date: 'Data Final',
      publication_date: 'Data da Publicação',
      publication: 'Publicação',
      detail: 'Detalhe',
      transited_judged_date: 'Data do Transitado-Julgado',
      coverage_defined_in_judicial_decision:
        'Cobertura Definida na Decisão Judicial',
      sanctioning_organ: 'Órgão Sancionador',
      sanctioning_organ_uf: 'UF do Órgão Sancionador',
      'applicants.0.name': 'Apelante(s)',
      'applicants.1.name': 'Apelado(a)(s)',
    },
  },
}
